import axios from 'axios';
import getHeaders from './headers';

const trackingEndpoint = `${process.env.VUE_APP_TRANSFER_TRACKING_API_URL}transfer-tracking/`;

export default {
  getStatus: (rut) => {
    const url = `${trackingEndpoint}${rut}`;
    const headers = getHeaders();
    return axios.get(url, { headers }).then(status => status.data);
  },
};
